"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Option = _ref => {
  let {
    children,
    isSelected,
    ...props
  } = _ref;
  // Remove the niceties for mouseover and mousemove to optimize for large lists
  // eslint-disable-next-line no-unused-vars
  const {
    onMouseMove,
    onMouseOver,
    ...rest
  } = props.innerProps;
  const newProps = {
    ...props,
    innerProps: rest
  };
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, (0, _extends2.default)({}, newProps, {
    className: `px-multi-select__option ${isSelected ? 'px-multi-select__option_selected' : ''}`
  }), children);
};
var _default = exports.default = Option;